export enum CardState {
    Unknown = 'unknown',
    Active = 'Active',
    Ordered = 'ordered',
    Expired = 'expired',
    Suspended = 'suspended',
    Closed = 'closed',
    Blocked = 'blocked',
}